import { Mock } from "../lib/appfuse-react/core/ajax";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import applicationDraftService from "../mock/applicationDraft/applicationDraftService";
import {applicationSurveyService} from "../mock/applicationDraft";
import inboxServices from "../mock/inbox";
import applicationTitleService from "../mock/applicationTitle/applicationTitleService";
import applicationService from "../mock/application/applicationService";
import markApplicationService from "../mock/markApplication/markApplicationService";
import renewalApplicationService from "../mock/renewalApplication/renewalApplicationService";
import basicDataService from "../mock/basicData/basicDataService";
import applicationHistoryService from "../mock/applicationHistory/applicationHistoryService";

const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService);
    mock.use(applicationDraftService);
    mock.use(applicationSurveyService);
    mock.use(inboxServices);
    mock.use(applicationTitleService);
    mock.use(applicationService);
    mock.use(markApplicationService);
    mock.use(renewalApplicationService);
    mock.use(basicDataService);
    mock.use(applicationHistoryService);
    return mock;
}());

const context = {mock};

export default context;

export {mock};